import { Injectable } from '@angular/core';
import { BaseServiceService } from '../base_service/base-service.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class BettingServiceService {

  URL: string
 

  constructor(private baseService:BaseServiceService , private http:HttpClient) {
    this.URL = this.baseService.baseUrl();
   } 

   // get sport icons
  getSportIcons(){
    const url_getSportIcons = this.URL  + 'meeting/sports';
    return this.http.get(url_getSportIcons);
  }

  // get bet results
  getBetResults(): Observable<any>{
    const url_betResults = this.URL + 'meeting/eventResults';
    return this.http.get(url_betResults);
  }

  // get bet results
  getEventResults(eventId): Observable<any>{
    const params = new HttpParams().set('eventId',eventId);
    const url_betResults = this.URL + 'meeting/eventResultsByEventId';
    return this.http.get(url_betResults,{
      responseType: 'json', 
      params: params,
    });
  }


  // get meeting data
  getBetslipResults(slipID,token){
    const params = new HttpParams()
    .set('slipId',slipID);
    const url =  this.URL + 'meeting/eventResults';
    return this.http.get(url,{
      responseType: 'json', 
      params: params,
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  

  // -----------------------------------------------------------------------------------------



  // Meetings

  // get meeting data
  getMeetingData(data:any){
    const params_ActiveMeeting = new HttpParams()
    .set('country',data.country)
    .set('date',data.date)
    .set('filter',data.filter)
    .set('inplay',data.inplay)
    .set('sport',data.sport);
    const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
    return this.http.get(url_activeMeetings,{
      responseType: 'json', 
      params: params_ActiveMeeting 
    });
  }

  // get sport meeting data
  getSportMeetingData(data:any){
    const params_ActiveMeeting = new HttpParams()
    .set('filter',data.filter)
    .set('inplay',data.inplay)
    .set('sport',data.sport);
    const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
    return this.http.get(url_activeMeetings,{
      responseType: 'json', 
      params: params_ActiveMeeting 
    });
  }

    // get meeting data by meeting ID
    getMeetingDataById(data:any){
      const params_ActiveMeetingByid = new HttpParams()
      .set('country',data.country)
      .set('date',data.date)
      .set('filter',data.filter)
      .set('inplay',data.inplay)
      .set('sport',data.sport)
      .set('meetingId',data.id)
      const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
      return this.http.get(url_activeMeetings,{
        responseType: 'json', 
        params: params_ActiveMeetingByid 
      });
    }

    // get Racing Roulet game meeting data by meeting ID
    getRacingRouletMeetingDataById(data:any){
      const params_ActiveMeetingByid = new HttpParams()
      .set('country',data.country)
      .set('date',data.date)
      .set('filter',data.filter)
      .set('inplay',data.inplay)
      .set('sport',data.sport)
      const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
      return this.http.get(url_activeMeetings,{
        responseType: 'json', 
        params: params_ActiveMeetingByid 
      });
    }

    // get Keno game meeting data by meeting ID
    getKenoMeetingDataById(data:any){
      const params_ActiveMeetingByid = new HttpParams()
      .set('country',data.country)
      .set('date',data.date)
      .set('filter',data.filter)
      .set('inplay',data.inplay)
      .set('sport',data.sport)
      const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
      return this.http.get(url_activeMeetings,{
        responseType: 'json', 
        params: params_ActiveMeetingByid 
      });
    }

    // get Lucky Loot game meeting data by meeting ID
    getLuckyLootMeetingDataById(data:any){
      const params_ActiveMeetingByid = new HttpParams()
      .set('country',data.country)
      .set('date',data.date)
      .set('filter',data.filter)
      .set('inplay',data.inplay)
      .set('sport',data.sport)
      const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
      return this.http.get(url_activeMeetings,{
        responseType: 'json', 
        params: params_ActiveMeetingByid 
      });
    }

  // get event metaData

  getEventMetaData(para: any){

      const params_EventMetaDataByid = new HttpParams()
      .set('id',para)
      const url_eventMetaData =  this.URL + 'meeting/eventMetaData'; 
      return this.http.get(url_eventMetaData, { 
      responseType: 'json', 
      params: params_EventMetaDataByid 
    });
  }    
   
      
  
  // -----------------------------------------------------------------------------------------


  
  // Events selections

  // get event selections
  getEventSelections(id:any){
    const url_eventSelections =  this.URL + 'meeting/eventSelections';
    const param_event = new HttpParams().set('eventId',id)
    
    return this.http.get(url_eventSelections,{
      responseType: 'json',
      params:param_event
    })
  }

  eventResultsBySelection(id:any){
    const url_eventSelections =  this.URL + 'meeting/eventResultsBySelection';
    const param_event = new HttpParams().set('eventId',id)
    
    return this.http.get(url_eventSelections,{
      responseType: 'json',
      params:param_event
    })
  }


  // get event start time
  getEventStartTime(){
    const url_eventStartTime =  this.URL + 'meeting/eventStartTime';
    return this.http.get(url_eventStartTime);
  }

    // get selection metaData
    getSelectionMetaData(para: any){
      const IdData = {id: para};
      const url_selectionMetaData =  this.URL + 'meeting/selectionMetaData';
      return this.http.get(url_selectionMetaData, {params: IdData});
    }

  // -----------------------------------------------------------------------------------------

  // TrackSide

  // get trackSide Result
  getTrackSideResult(){
    const trackEventResult = this.URL + 'meeting/trackSideEventResults72';
    return this.http.get(trackEventResult);
  }

  // get trackSide video URL
  getTrackVideoUrl(token){
    const trackSVUrl =  this.URL + 'meeting/tracksideVideoURL';
    return this.http.get(trackSVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  // Kiron 
  // get Kiron Result
  getKironResult(){
    const kironResult =  this.URL + 'meeting/kironEventResults';
    return this.http.get(kironResult);
  }

  // get Kiron HR video URL
  getKironHRVideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kironHRVideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

   // get Kiron DG video URL
   getKironDGVideoUrl(token){
    const kironDGVUrl =  this.URL + 'meeting/kironDGVideoURL';
    return this.http.get(kironDGVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  eventStartTime(para: any){
    //const IdData = {id: para};
    const url_selectionMetaData =  this.URL + 'meeting/eventStartTime?eventId='+para;
    return this.http.get(url_selectionMetaData);
  }

  //kiron 2 nova
  getKiron2Result(){
    const kironResult =  this.URL + 'meeting/kiron2EventResults';
    return this.http.get(kironResult);
  }

  //kiron 3 lucky horse
  getKiron3Result(){
    const kironResult =  this.URL + 'meeting/kiron3EventResults';
    return this.http.get(kironResult);
  }

  // get Kiron 2 nova video URL
  getKiron2VideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kiron2VideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  // get Kiron 3 lucky horse video URL
  getKiron3VideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kiron3VideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  //kiron 4 cricket super over
  getKiron4Result(){
    const kironResult =  this.URL + 'meeting/kiron4EventResults';
    return this.http.get(kironResult);
  }

  // get Kiron 4 cricket super over video URL
  getKiron4VideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kiron4VideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  getCricketSuperOverMeetingData(){
    const params_ActiveMeeting = new HttpParams()
    .set('filter',"4");
    const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
    return this.http.get(url_activeMeetings,{
      responseType: 'json', 
      params: params_ActiveMeeting 
    });
  }

  // get meeting data by meeting ID
  getCricketSuperOverMeetingDataById(id:any){
    const params_ActiveMeetingByid = new HttpParams()
    .set('filter',"4")
    .set('meetingId',id)
    const url_activeMeetings =  this.URL + 'meeting/activeMeetings';
    return this.http.get(url_activeMeetings,{
      responseType: 'json', 
      params: params_ActiveMeetingByid 
    });
  }

  //kiron 8 RR
  getKiron8Result(){
    const kironResult =  this.URL + 'meeting/kiron8EventResults';
    return this.http.get(kironResult);
  }

  //kiron 6 Keno
  getKiron6Result(){
    const kironResult =  this.URL + 'meeting/kiron6EventResults';
    return this.http.get(kironResult);
  }

  //kiron 7 LL
  getKiron7Result(){
    const kironResult =  this.URL + 'meeting/kiron7EventResults';
    return this.http.get(kironResult);
  }


   // -----------------------------------------------------------------------------------------

  // Betting

  // get event selections
  getEventSelectionforBetPlace(selections, token ){
    const url_eventSelection =  this.URL + 'betting/eventSelection';
    return this.http.put(url_eventSelection, selections, {
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + token)
    })
  }

  // For Krion Games
  getEventSelectionforBetPlace_mdm(selections, token ){
    const url_eventSelection =  this.URL + 'betting/eventSelectionMDM';
    return this.http.post(url_eventSelection, selections, {
      headers: new HttpHeaders()
        .set('Authorization', 'Token ' + token)
    })
  }

    // submit bet
    submitBet(data,token,betSlipToken){
      //const url_submitBet =  this.URL + 'betting/bet';  27-9-21 changed betv2
      const url_submitBet =  this.URL + 'betting/betV2';
      return this.http.put(url_submitBet,data,{
        params: new HttpParams().set('betSlipToken', betSlipToken),
        headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)          
      });
    }

    // get all events for results

  getAllevents(data:any){
    const  params_AllEvents= new HttpParams()
    .set('eventDate',data.eventDate)
    .set('category',data.category);
    const url_activeMeetings =  this.URL + 'meeting/allevents';
    return this.http.get(url_activeMeetings,{
      responseType: 'json', 
      params: params_AllEvents 
    });
  }


  //---------------------- GAMES --------------------------------

  // Racing Roulette video URL
  getKiron8VideoUrl(token){
    const kironRRVUrl =  this.URL + 'meeting/kiron8VideoURL';
    return this.http.get(kironRRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

   // Keno Game video URL
  getKiron6VideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kiron6VideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }
  
  // Lucky Loot Game video URL
  getKiron7VideoUrl(token){
    const kironHRVUrl =  this.URL + 'meeting/kiron7VideoURL';
    return this.http.get(kironHRVUrl,{
      responseType: 'json',
      headers: new HttpHeaders()
          .set('Authorization', 'Token ' + token)
    });
  }

  // getRacingRouletteVideoUrl(){
  //   return 'https://video.stbet.com/horseracingroulette/ewb320p/playlist.m3u8';
  // }

  // getKenoVideoUrl(){
  //   return 'https://video.stbet.com/keno/ewb320p/playlist.m3u8';
  // }

  getLuckyLootVideoUrl(){
    return 'https://video.stbet.com/luckyloot/ewb320p/playlist.m3u8';
  }

}
